import { useLocale } from '../i18n/LocaleContext'
import FAQ from '../components/FAQ'
import SEOHead from '../components/SEOHead'

export default function Faq() {
  const { t } = useLocale()
  return (
    <>
      <SEOHead title={t.faq.metaTitle} description={t.faq.metaDescription} />
      <FAQ />
    </>
  )
}
